var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-center py-1" },
    [
      _c("b-col", { attrs: { md: "4", col: "" } }, [
        _c(
          "span",
          { staticClass: "collapse-handle cursor-move mr-2" },
          [
            _c("icon", {
              staticClass: "text-light-gray bold",
              attrs: { name: "bars" },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _vm.hasSampleDocuments
          ? _c(
              "a",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle",
                    value: _vm.documentRequest.id,
                    expression: "documentRequest.id",
                  },
                ],
                staticClass: "clickable",
              },
              [
                _c(
                  "h5",
                  { staticClass: "mb-0 font-sm text-light-gray bold d-inline" },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.documentRequest.classification) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("icon", {
                  staticClass: "text-light-gray",
                  attrs: { name: _vm.visible ? "caret-down" : "caret-right" },
                }),
              ],
              1
            )
          : _c(
              "h5",
              { staticClass: "mb-0 font-sm text-light-gray bold d-inline" },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.documentRequest.classification) +
                    "\n    "
                ),
              ]
            ),
      ]),
      _vm._v(" "),
      _c("b-col", { staticClass: "d-md-block d-none", attrs: { col: "" } }, [
        _c(
          "div",
          { staticClass: "collapsee-body py-0" },
          [
            _c(
              "b-row",
              { attrs: { "no-gutters": "" } },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12" } },
                  [
                    _c("editable-description", {
                      attrs: {
                        loading: _vm.savingDescription,
                        description: _vm.description,
                      },
                      on: { save: _vm.handleSaveDescription },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "b-col",
        { staticClass: "d-flex flex-row", attrs: { cols: "auto" } },
        [
          !_vm.documentRequest.draft
            ? [
                _vm.uploading
                  ? _c(
                      "span",
                      {
                        staticClass:
                          "btn request-from-type text-primary bold text-right d-flex flex-row align-items-center py-0",
                      },
                      [
                        _c("inline-loader", { staticClass: "mr-1" }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("global.words.uploading")) +
                            "...\n      "
                        ),
                      ],
                      1
                    )
                  : _c(
                      "a",
                      {
                        staticClass:
                          "request-upload-sample clickable mr-4 bold text-primary",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.fileInput.click()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("documents.uploadSampleDocument")) +
                            "\n      "
                        ),
                      ]
                    ),
                _vm._v(" "),
                _c("input", {
                  ref: "fileInput",
                  staticStyle: { display: "none" },
                  attrs: {
                    id: _vm.labelValue,
                    type: "file",
                    accept:
                      "application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/msword,image/png,image/tiff,image/jpeg",
                    multiple: "",
                  },
                  on: { change: _vm.handleFilesSelected },
                }),
                _vm._v(" "),
                _c(
                  "label",
                  { staticClass: "d-none", attrs: { for: _vm.labelValue } },
                  [_vm._v(_vm._s(_vm.$t("documents.uploadSampleDocument")))]
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "request-trash" },
            [
              _c("inline-prompt", {
                attrs: { "action-type": "delete", placement: "left" },
                on: { accept: _vm.handleDelete },
              }),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }